// extracted by mini-css-extract-plugin
export default {"frame":"chartCanvas_frame__Qq85e"};